import { render, staticRenderFns } from "./DonorEditor.vue?vue&type=template&id=5b74ad3e&"
import script from "./DonorEditor.vue?vue&type=script&lang=ts&"
export * from "./DonorEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports